import init from './init';
import modalSection from './sections/modal';
import headerSection from './sections/header';
import productPage from "./pages/product";
// import tourplanFunctions from "./pages/tourplan";
import newsPage from "./pages/news";
import contactPage from "./pages/contact";
import searchPage from "./pages/search";
import checkoutPage from "./pages/checkout";
import bookingPage from "./pages/booking";
import footerSection from "./sections/footer";
import currencySelector from "./sections/currencySelector";
import favouritesSection from "./sections/favourites";

// All new product enhancements
import products from "./products/main";

init();
modalSection();
headerSection();
footerSection();
productPage();
// tourplanFunctions();
checkoutPage();
bookingPage();
newsPage();
contactPage();
searchPage();
currencySelector();
favouritesSection();
products();

/** cookie banner */
let lscook = localStorage.getItem('showCookieBanner');
let showCookieBanner = lscook ? lscook !== 'NO' : true;
if (showCookieBanner) {
  const cookieBanner = document.querySelector('div.cookie-banner');
  const cookieBannerDetails = document.querySelector('div.cookie-banner details');
  const cookieBannerButton = document.querySelector('div.cookie-banner details button');
  cookieBanner.classList.remove('hidden');
  if (cookieBanner) {
    cookieBannerDetails.addEventListener('click', event => {
      cookieBanner.classList.toggle('-opened');
    });
    cookieBannerButton.addEventListener('click', event => {
      localStorage.setItem('showCookieBanner', 'NO');
      cookieBanner.remove();
    })
  }
}


// WEBPACK FOOTER //
// ./source/scripts/main.js